export const cleanName = (name?: string) => (name ?? "").replace("_", " ");
